
import 'devextreme/dist/css/dx.light.css';
import './index.css';
import './polyfills';
import './pop-up.css';
import './text-editor.css';
import './data-grid.css';
import { store } from "./state/store";
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
